import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "w-full py-6 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Sync", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex items-center mb-2 text-red-600"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, [
  /*#__PURE__*/_createTextVNode("The record highlighted in "),
  /*#__PURE__*/_createElementVNode("strong", null, "red"),
  /*#__PURE__*/_createTextVNode(" has a match in the system. Please click check to resolve.")
], -1)
const _hoisted_5 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "text-xs italic text-red-600" }
const _hoisted_7 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_8 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_9 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_10 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_11 = { class: "flex items-center justify-center mx-auto" }
const _hoisted_12 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_13 = { class: "px-6 py-6 text-sm text-center text-gray-900 whitespace-nowrap" }
const _hoisted_14 = { class: "px-6 py-6 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_15 = {
  key: 0,
  class: "flex items-center justify-center mx-auto"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Sync", -1)

import { ref, onMounted, computed, watch } from "vue";
import UserLayout from '@/layouts/UserLayout.vue';
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import DataTable from "@/components/partials/DataTable.vue";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import SyncModal from "@/components/modals/SyncModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import ResolutionModal from './Components/ResolutionModal.vue';
import DeleteConfirmationModal from '@/components/modals/DeleteConfirmationModal.vue';
import SyncConfirmationModal from '@/components/modals/SyncConfirmationModal.vue';
import CheckButton from '@/components/buttons/CheckButton.vue';
import ViewButton from '@/components/buttons/ViewButton.vue';
import DeleteButton from '@/components/buttons/DeleteButton.vue';
import { ArrowPathIcon } from "@heroicons/vue/24/solid";
import { ExclamationCircleIcon } from "@heroicons/vue/24/outline";
import PageLoader from "@/components/loaders/PageLoader.vue"

import { EnumsInterface } from "@/interfaces/EnumsInterface";

import { SyncStatus } from "@/views/enums/SyncStatus";

import DraftTypesOptions from "@/enums/DraftTypesOptions"
import SyncStatusOptions from "@/enums/SyncStatusOptions";
import Storage from "@/helpers/storage";

import { useRouter } from "vue-router";

import DraftService from "@/classes/Drafts/DraftService";
import { onIonViewWillEnter } from "@ionic/vue";
import Relationships from "@/classes/Forms/Relationships";
import { useDraftLogger } from "@/store/draftlogger";
import http from "@/axios";
import { useNetworkStore } from "@/store/network";
import OnlineSynching from "@/classes/Synching/OnlineSynching";
import { RoleTypes } from "../enums/RoleTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
const storage = new Storage();
const showSync = ref<boolean>(false);
const showSyncSuccess = ref<boolean>(false);

const showPublish = ref<boolean>(false);
const showPublishSuccess = ref<boolean>(false);
const transform = new Relationships();
const showResolution = ref<boolean>(false);
const showResolutionConfirmation = ref<boolean>(false);
const showResolutionNewConfirmation = ref<boolean>(false);
const manualSync = computed(() => localStorage.getItem('cpn-online-sync-attemp') ? true : false);

const tokens = new Storage();

const user = JSON.parse(tokens.get("user"));

const resolveStatus = computed<boolean>(() => {
    if (hasErrors.value) {
        return false;
    }
    return true;
});

const items = ref<any>([]);

const loading = ref<boolean>(true);

const showDeleteConfirmation = ref<boolean>(false);
const showDeleteSuccess = ref<boolean>(false);

const selectedRecord = ref<any | null>(null);
const draft = useDraftLogger();
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const isActualNetworkAvailable = computed(() => networkStore.isActualNetworkAvailable);
const onlineSync = new OnlineSynching();
const hasErrors = ref<boolean>(false)

const getLabel = (id: number, options:Array<EnumsInterface>): string => {
	const index = options.findIndex(option => option.value === id);
    if (index > -1) {
        return options[index].label;
    }
    return "";
}

const init = async (): Promise<void> => {
    items.value = [];
    await renderPatients(true);
    await renderCases(true);
    await renderCaseGuardians(true);
    await renderCaseInformant(true);
    await renderPerpetrators(true);
    await renderCasePerpetrator(true);
    await renderInterventions(true);
    await renderCaseConferenceInformation(true);
    await renderCaseConferenceFactor(true);
    await renderCaseConferenceRecommendation(true);
    await renderCasePatientAddress(true);
    await renderIntakePersonnalInformation(true);
    await renderIntakePersonRelatedToCase(true);
    await renderIntakeContactNumber(true);
    await renderIntakeEmail(true);
    await renderIntakeIncestCase(true);
    await renderCaseSafeAssessment(true);
    loading.value = false;
}

const defaultResponseBuilder = (response: any, isRenderData = false) => {
    items.value.push(...response.items);
    hasErrors.value = response.hasError;
    if (response.hasError && isRenderData) {
        loading.value = false;
    }
    if (response.hasError && !isRenderData) {
        showSync.value = false;
    }
    return response.hasError;    
}

const renderPatients = async (isRenderData = false) => {
    const response = await onlineSync.renderPatients(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderCases = async (isRenderData = false) => {
    const response = await onlineSync.renderCases(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderPerpetrators = async (isRenderData = false) => {
    const response = await onlineSync.renderPerpetrators(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderCasePerpetrator = async (isRenderData = false) => {
    const response = await onlineSync.renderCasePerpetrator(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderCaseGuardians = async (isRenderData = false) => {
    const response = await onlineSync.renderCaseGuardians(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderCaseInformant = async (isRenderData = false) => {
    const response = await onlineSync.renderCaseInformant(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderCasePatientAddress = async (isRenderData = false) => {
    const response = await onlineSync.renderCasePatientAddress(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderInterventions = async (isRenderData = false) => {
    const response = await onlineSync.renderInterventions(isRenderData);
	return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderIntakePersonnalInformation = async (isRenderData = false) => {
    const response = await onlineSync.renderIntakePersonnalInformation(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderIntakePersonRelatedToCase = async (isRenderData = false) => {
    const response = await onlineSync.renderIntakePersonRelatedToCase(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderIntakeContactNumber = async (isRenderData = false) => {
    const response = await onlineSync.renderIntakeContactNumber(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderIntakeEmail = async (isRenderData = false) => {
    const response = await onlineSync.renderIntakeEmail(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderIntakeIncestCase = async (isRenderData = false) => {
    const response = await onlineSync.renderIntakeIncestCase(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderCaseSafeAssessment = async (isRenderData = false) => {
    const response = await onlineSync.renderCaseSafeAssessment(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderCaseConferenceInformation = async (isRenderData = false) => {
    const response = await onlineSync.renderCaseConferenceInformation(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderCaseConferenceFactor = async (isRenderData = false) => {
    const response = await onlineSync.renderCaseConferenceFactor(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

// @TODO for updating
const renderCaseConferenceRecommendation = async (isRenderData = false) => {
    const response = await onlineSync.renderCaseConferenceRecommendation(isRenderData);
    return defaultResponseBuilder(response, isRenderData);
}

const showDeleteModal = (item: any): void => {
	showDeleteConfirmation.value = true;
	selectedRecord.value = item;
};

const deleteRecord = async (): Promise<void> => {
    showDeleteConfirmation.value = false;
	loading.value = true
    const item = selectedRecord.value;
    await onlineSync.deleteDraft(item);
    items.value = [];
    await init();
    draft.hasDraft = true;
    loading.value = false;
}

const closeDeleteModal = (): void => {
	showDeleteSuccess.value = false;
};

const patientLists = ref({});
const selectedForm = ref(null);
const lookupPatients = async (item: any) => {
    const response = await http.post('/attemp-synching-patient-lookup', item).catch(error => error);
    if (response?.status === 200) {
        patientLists.value = {
            items: response.data,
            form: item,
        };
        showResolution.value = true;
    }
}

const syncPatient = (item: any, formItem: any) => {
    selectedForm.value = null;
    if (!isActualNetworkAvailable.value) {
        return;
    }
    showResolution.value = false; 
    showResolutionConfirmation.value = true
    formItem.newId = item.id;
    selectedForm.value = formItem;
}

const syncCreatePatient = async (item: any, formItem: any) => {
    selectedForm.value = null;
    if (!isActualNetworkAvailable.value) {
        return;
    }
    showResolution.value = false; 
    showResolutionNewConfirmation.value = true
    selectedForm.value = formItem;
    await processCreateSynching();
}

const processSynching = async () => {
    if (!isActualNetworkAvailable.value) {
        return;
    }
    
    showSync.value = true; 
    showResolutionConfirmation.value = false;
    const response = await onlineSync.processSynching(selectedForm.value);
    hasErrors.value = response;
    await init();
    showSync.value = false; 
    draft.hasDraft = true;
}

const processCreateSynching = async () => {
    if (!isActualNetworkAvailable.value) {
        return;
    }
    
    showSync.value = true; 
    showResolutionNewConfirmation.value = false;
    const response = await onlineSync.processCreateSynching(selectedForm.value);
    hasErrors.value = response;
    await init();
    showSync.value = false; 
    draft.hasDraft = true;
}

const reSync = async () => {
    await attempSynching();
    await init();
}

const attempSynching = async () => {
    if (!isActualNetworkAvailable.value) {
        showSync.value = false;
        return;
    }
    showSync.value = true;
    draft.hasDraft = false;
    const resultPatient = await renderPatients();
    if (!resultPatient) {
        const resultCase = await renderCases();
        if (!resultCase) {
            await renderCaseGuardians();
            await renderCaseInformant();
            await renderCasePatientAddress();
            const resultPerpetrator = await renderPerpetrators();
            if (!resultPerpetrator) {
                await renderCasePerpetrator();                
            }
            await renderInterventions();
            const resultCaseConference = await renderCaseConferenceInformation();
            console.log(resultCaseConference, 'case conference synching result')
            if (!resultCaseConference) {
                // process related case conference
                await renderCaseConferenceFactor();
                await renderCaseConferenceRecommendation();
            }

            const resultIntake = await renderIntakePersonnalInformation();
            if (!resultIntake) {
                // process related case conference
                await renderIntakePersonRelatedToCase();
                await renderIntakeContactNumber();
                await renderIntakeEmail();
                await renderIntakeIncestCase();
                await renderCaseSafeAssessment();
            }
        }
    }
    await onlineSync.checkDrafts();
    // @TODO temporary hidden for fixing
    // if (!resultPatient) {
    //     const resultCase = await renderCases();
    //     if (!resultCase) {


    //         await renderCaseSafeAssessment();
    //     }
    // }

    if (resolveStatus.value)  {
        draft.count = 0;
    }
    draft.hasDraft = true;
    showSync.value = false;
    showSyncSuccess.value = true;
}

const refreshPage = () => {
    showSyncSuccess.value = false
    gotoDashboard(user.role_id);
}


const gotoDashboard = (role:number):void =>{
    const wcpuRoles = [
        RoleTypes.OFFICE_ADMIN,
        RoleTypes.OFFICE_NORMAL,
        RoleTypes.NURSE,
        RoleTypes.WCPU,
        RoleTypes.OFFICE_TRAINEE,
    ]

    if(wcpuRoles.includes(role)){
		router.push({ name: "DashboardIndexPageWcpu" })
    } else {
		router.push({ name: "DashboardIndexPage" })
    }
}


onIonViewWillEnter(async () => {
    items.value = [];
    draft.hasDraft = false;
    if (!localStorage.getItem('cpn-online-sync-attemp')) {
        // await attempSynching();
        localStorage.setItem('cpn-online-sync-attemp', 1);
    }
    loading.value = true;
    await init();
    await onlineSync.checkDrafts();
});

watch(
    () => isActualNetworkAvailable.value,
    async (val) => {
        if (!val) {
            window.location.reload();
            // showSyncSuccess.value = false;
            // loading.value = false;
            // await init();
            // await onlineSync.checkDrafts();
        }
    }
);

const headers: { text: string; haveSort?: boolean }[] = [
	{ text: "Name" },
	{ text: "Birthday" },
	{ text: "Type" },
	{ text: "Date Created/Updated" },
	{ text: "Status" },
];

const resolutionHeaders: { text: string; haveSort?: boolean }[] = [
	{ text: "Patient Name" },
	{ text: "Latest Case No." }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex items-start justify-between", resolveStatus.value ? 'mb-4' : 'mb-6'])
        }, [
          _createVNode(SectionTitle, {
            title: "Drafted Records",
            description: "View the drafts in the system."
          }),
          (items.value.length > 0 && isActualNetworkAvailable.value)
            ? (_openBlock(), _createBlock(ButtonComponent, {
                key: 0,
                disabled: !manualSync.value,
                onClick: reSync,
                customClass: "bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700\n\t\t\t\t\tdisabled:bg-gray-300 disabled:cursor-disabled disabled:text-white\n\t\t\t\t\t"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowPathIcon), {
                    class: "w-4 h-4 mr-1 text-white",
                    "aria-hidden": "true"
                  }),
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ], 2),
        (!resolveStatus.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(ExclamationCircleIcon), {
                class: "w-6 h-6 mr-1",
                "aria-hidden": "true"
              }),
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createVNode(DataTable, {
            headers: headers,
            "no-action": false,
            count: items.value.length,
            tableClass: "header-frm-table"
          }, {
            body: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item,
                  class: _normalizeClass(item.status == 'To Resolve' ? 'bg-red-600 bg-opacity-10' : '')
                }, [
                  _createElementVNode("td", _hoisted_5, [
                    _createTextVNode(_toDisplayString(item.patient_name) + " ", 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(item.synching_remarks), 1)
                  ]),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(item.birthdate_formatted), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(item.type), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(_unref(transform).dateFormat(item.updated_at, 'DD hh:mm a')), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["px-6 py-6 text-sm whitespace-nowrap", item.status == _unref(SyncStatus).RECORD_CONFLICT ? 'text-red-600' :
									item.status ==  _unref(SyncStatus).SYNC ? 'text-green-600' : 'text-gray-900'])
                  }, _toDisplayString(getLabel(item.status, _unref(SyncStatusOptions))), 3),
                  _createElementVNode("td", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      (item.table === 'patients' && item.is_created_offline && isActualNetworkAvailable.value)
                        ? (_openBlock(), _createBlock(CheckButton, {
                            key: 0,
                            onClick: ($event: any) => (lookupPatients(item))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.url_view && !isNetworkAvailable.value && item.can_view)
                        ? (_openBlock(), _createBlock(ViewButton, {
                            key: 1,
                            class: "mr-2",
                            onClick: ($event: any) => (_unref(router).replace(item.url_view))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.status != _unref(SyncStatus).SYNC)
                        ? (_openBlock(), _createBlock(DeleteButton, {
                            key: 2,
                            onClick: ($event: any) => (showDeleteModal(item))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              }), 128))
            ]),
            _: 1
          }, 8, ["count"])
        ])
      ]),
      _createVNode(DeleteConfirmationModal, {
        typeTwo: true,
        show: showDeleteConfirmation.value,
        onCancel: _cache[0] || (_cache[0] = ($event: any) => (showDeleteConfirmation.value = false)),
        onConfirm: deleteRecord,
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Discard Draft",
        content: "Are you sure you wish to discard this draft? "
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showDeleteSuccess.value,
        onConfirm: closeDeleteModal,
        "action-text": "Close",
        title: "Draft Discarded!",
        content: "Draft has been successfully discarded"
      }, null, 8, ["show"]),
      _createVNode(SyncModal, {
        title: "Record Syncing",
        content: "Please don't close while the data is syncing",
        show: showSync.value,
        onConfirm: _cache[1] || (_cache[1] = ($event: any) => {
				showSync.value = false;
				showSyncSuccess.value = true;
			}),
        width: "w-[480px]"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSyncSuccess.value,
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (refreshPage())),
        "action-text": "Close",
        title: "Record Synced!",
        content: "Offline record has been successfully synced. Redirecting back to the dashboard"
      }, null, 8, ["show"]),
      _createVNode(SyncModal, {
        title: "Publishing Records",
        content: "Please don't close while the record is publishing",
        show: showPublish.value,
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => {
				showPublish.value = false;
				showPublishSuccess.value = true;
			}),
        width: "w-[480px]"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showPublishSuccess.value,
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showPublishSuccess.value = false)),
        "action-text": "Close",
        title: "Record Published!",
        content: "Offline drafts has been successfully published"
      }, null, 8, ["show"]),
      _createVNode(ResolutionModal, {
        show: showResolution.value,
        onCancel: _cache[5] || (_cache[5] = ($event: any) => (showResolution.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (syncCreatePatient(_ctx.item, patientLists.value.form))),
        "cancel-text": "Cancel",
        "action-text": "Create New Record",
        title: "Resolution Panel",
        description: "Select patient you want to save the record",
        "is-network-available": isActualNetworkAvailable.value
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(DataTable, {
              headers: resolutionHeaders,
              "no-action": false,
              count: patientLists.value.items.length
            }, {
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patientLists.value.items, (item) => {
                  return (_openBlock(), _createElementBlock("tr", { key: item }, [
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.name), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(item.latest_case_number), 1),
                    _createElementVNode("td", _hoisted_14, [
                      (isActualNetworkAvailable.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createVNode(ButtonComponent, {
                              onClick: ($event: any) => (syncPatient(item, patientLists.value.form)),
                              size: "small",
                              customClass: "bg-green-600 hover:bg-green-700 text-white transition border border-green-600 hover:border-green-700 px-2 mr-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ArrowPathIcon), {
                                  class: "w-4 h-4 mr-1 text-white",
                                  "aria-hidden": "true"
                                }),
                                _hoisted_16
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["count"])
          ])
        ]),
        _: 1
      }, 8, ["show", "is-network-available"]),
      _createVNode(SyncConfirmationModal, {
        typeTwo: true,
        show: showResolutionConfirmation.value,
        onCancel: _cache[7] || (_cache[7] = ($event: any) => (showResolutionConfirmation.value = false)),
        onConfirm: _cache[8] || (_cache[8] = ($event: any) => (processSynching())),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Sync Record",
        content: "Are you sure you wish to sync this record to the existing patient?"
      }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})